import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { PtCoreActions, PtCoreSelectors } from '@pt/pt-core';
import { PrimatooManageEntity, PtPermissions, PtUiAppRoutes } from '@pt/pt-models';
import { Subject } from 'rxjs';
import { ActivatedRoute, Params } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { PrimatooModule } from 'it/primatoo/openapi/api/org/schemas/common/PrimatooModule';

@Component({
  selector: 'pt-forbidden-module',
  template: `
    <pt-auth-img-area class="position-absolute" style="top: 0; left: 0" [showPTLogo]="false"></pt-auth-img-area>
    <div class="w-100 vh-100 d-flex flex-column justify-content-center align-items-center">
      <div class="d-flex flex-row justify-content-center">
        <div class="d-flex flex-column justify-content-start">
          <!--          <div class="w-100 text-center text-black-50" style="font-size: 8vw">-->
          <!--            Ooops!&lt;!&ndash;{{errorCode}}&ndash;&gt;-->
          <!--          </div>-->
          <pt-no-active-module
            *ngIf="module"
            [primatooModule]='module'
          ></pt-no-active-module>

          <pt-no-active-management-module
            *ngIf="entity"
            [primatooEntity]="entity">
          </pt-no-active-management-module>

          <!--          <div class="h3 text-muted text-center mt-4 message-container">-->
          <!--            Gestione del modulo mancante...-->
          <!--          </div>-->
        </div>
      </div>
      <!--      <button class="btn btn-outline-primary btn-sm mt-3 w-200-px mb-4" (click)="toAction()">-->
      <!--        OK&lt;!&ndash;{{'LABELS.BACK_TO_HOME' | translate}}&ndash;&gt;-->
      <!--      </button>-->
    </div>
  `,
  styles: [`
    #ptLink {
      color: grey;
    }
  `],
  encapsulation: ViewEncapsulation.None
})
export class ForbiddenModuleComponent implements OnInit, OnDestroy {
  public readonly PrimatooModule = PrimatooModule;

  public module?: PrimatooModule;
  public entity?: PrimatooManageEntity;
  private activeModulesAndPermission$ = this.store.select(PtCoreSelectors.activeModulesAndPermission);

  private destroy$: Subject<boolean> = new Subject<boolean>();
  private activeModules: PrimatooModule[];
  private activePermissions: PtPermissions[];

  constructor(
    private store: Store,
    private activatedRoute: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.activeModulesAndPermission$.pipe(
      takeUntil(this.destroy$)).subscribe((r) => {
      this.activeModules = r.activeModules;
      this.activePermissions = r.activePermissions;
      this.alignQueryParams();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  private alignQueryParams() {
    this.activatedRoute.queryParams.pipe(
      takeUntil(this.destroy$)
    ).subscribe((params: Params) => {
      if (params) {
        const currentParam: string = params.m || 'NONE';

        if (Object.keys(PrimatooModule).includes(currentParam)) {
          switch (currentParam) {
            case PrimatooModule.AI:
            case PrimatooModule.COVID:
            case PrimatooModule.CYBERSEC:
            case PrimatooModule.ENISA:
              this.module = currentParam;
              this.entity = undefined;
              break;
            case PrimatooModule.DATABREACH:
              if (this.activeModules?.length > 0 && this.activeModules.includes(PrimatooModule.DATABREACH)) {
                this.module = currentParam;
                this.entity = undefined;
              } else {
                this.module = undefined;
                this.entity = PrimatooManageEntity.DATABREACH;
              }
              break;
            default:
              this.module = undefined;
              this.entity = PrimatooManageEntity.NONE;
          }
        } else {
          this.module = undefined;
          this.entity = currentParam as PrimatooManageEntity;
        }
      } else {
        this.entity = PrimatooManageEntity.NONE;
        this.module = undefined;
      }
    });
    //
    // if (r.activePermissions?.includes(PtPermissions.MANAGE_WORKSPACE)) {
    //   return true;
    // } else {
    //   this.store.dispatch(PtCoreActions.navigateTo({
    //     route: [PtUiAppRoutes.FORBIDDEN_MODULE],
    //     queryParams: {
    //       module: 'WORKSPACE'
    //     }
    //   }));
    //   return false;
    // }
  }
}
